import React from "react";

// Shared avatar with a Tecticonism-wordmark fallback.
// Sizes are Tailwind width classes so callers can theme them freely.
// If `src` is a data URL / http URL we render the image; otherwise the fallback
// (a neutral circle with the small brand wordmark).
export function Avatar({ src, name, size = "w-9 h-9", className = "", "data-testid": testId }) {
  const [failed, setFailed] = React.useState(false);
  const initials = (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("");
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name || "User avatar"}
        className={`${size} rounded-full object-cover border border-slate-200 ${className}`}
        data-testid={testId}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <div
      className={`${size} rounded-full border border-slate-200 bg-slate-50 flex items-center justify-center overflow-hidden ${className}`}
      data-testid={testId}
      title={name || ""}
    >
      <img
        src="/tecticonism-wordmark-sm.png"
        alt=""
        aria-hidden="true"
        className="w-3/5 h-3/5 object-contain opacity-80"
      />
      <span className="sr-only">{initials}</span>
    </div>
  );
}
